const CACHE_PREFIX = "education-ui";

export const getEducationPageCacheKey = (page, parts = {}) => {
  const suffix = Object.entries(parts)
    .filter(([, value]) => value !== undefined && value !== null && value !== "")
    .map(([key, value]) => `${key}:${value}`)
    .join(":");

  return `${CACHE_PREFIX}:${page}${suffix ? `:${suffix}` : ""}`;
};

export const readEducationPageCache = (key, options = {}) => {
  try {
    const cached = localStorage.getItem(key);
    if (!cached) return null;
    const parsed = JSON.parse(cached);
    const maxAgeMs = Number(options.maxAgeMs || 0);
    if (maxAgeMs > 0 && parsed?.updatedAt && Date.now() - parsed.updatedAt > maxAgeMs) {
      return null;
    }
    return parsed?.data || null;
  } catch {
    return null;
  }
};

export const writeEducationPageCache = (key, data) => {
  try {
    localStorage.setItem(key, JSON.stringify({ data, updatedAt: Date.now() }));
  } catch {
    // Ignore storage failures; API data still renders normally.
  }
};
